<template>
  <div>
    <div class="bg-gray-50 w-full h-full flex flex-col justify-center">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slideshow",
  components: {},
};
</script>
